import React, { ChangeEventHandler, CSSProperties, FC, Ref } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input, InputRef } from 'antd';

import './InputSearch.scss';

type Props = {
  inputRef?: Ref<InputRef>;
  className?: string;
  disabled?: boolean;
  onChange?: ChangeEventHandler;
  placeholder?: string;
  value?: string;
  style?: CSSProperties;
};

const InputSearch: FC<Props> = ({
  inputRef,
  className,
  disabled,
  onChange,
  placeholder,
  value,
  style,
}) => {
  return (
    <Input.Search
      prefix={<SearchOutlined className="prefix-search-icon" />}
      className={className}
      ref={inputRef}
      disabled={disabled}
      onChange={onChange}
      placeholder={placeholder}
      allowClear
      value={value}
      style={style}
      enterButton={null}
    />
  );
};

export default InputSearch;
